export const DEVICE: string = 'PWA';

export default DEVICE;
